export enum ValidSteps {
    IN_AREA = 'in_area',
    OUT_AREA = 'out_area',
    CUSTOMER_ARRIVAL = 'customer_arrival',
    CUSTOMER_DEPARTURE = 'customer_departure',
    WEBHOOK = 'webhook',
    APP = 'app',
    ORIGIN = 'origin',
}

export enum AreaSteps {
    IN_AREA = 'in_area',
    OUT_AREA = 'out_area',
}

export enum CustomerSteps {
    CUSTOMER_ARRIVAL = 'customer_arrival',
    CUSTOMER_DEPARTURE = 'customer_departure',
}

export enum WebhookSteps {
    WEBHOOK = 'webhook',
}
